import ComplianceModal from './ComplianceModal';

export default ComplianceModal;
